/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Waitlist_ErrorInputs */

const en_booking_waitlist_error = /** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to join waitlist.`)
};

const es_booking_waitlist_error = /** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al unirse a la lista de espera.`)
};

const fr_booking_waitlist_error = /** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'inscription à la liste d'attente.`)
};

const de_booking_waitlist_error = /** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Beitreten der Warteliste.`)
};

const id_booking_waitlist_error = /** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal bergabung dengan daftar tunggu.`)
};

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const ja_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const zh_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const ar_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const it_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const ru_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const pt_booking_waitlist_error = en_booking_waitlist_error;

/** @type {(inputs: Booking_Waitlist_ErrorInputs) => LocalizedString} */
const ko_booking_waitlist_error = en_booking_waitlist_error;

/**
* | output |
* | --- |
* | "Failed to join waitlist." |
*
* @param {Booking_Waitlist_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_waitlist_error = /** @type {((inputs?: Booking_Waitlist_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Waitlist_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_waitlist_error(inputs)
	if (locale === "es") return es_booking_waitlist_error(inputs)
	if (locale === "fr") return fr_booking_waitlist_error(inputs)
	if (locale === "de") return de_booking_waitlist_error(inputs)
	if (locale === "ja") return ja_booking_waitlist_error(inputs)
	if (locale === "zh") return zh_booking_waitlist_error(inputs)
	if (locale === "ar") return ar_booking_waitlist_error(inputs)
	if (locale === "id") return id_booking_waitlist_error(inputs)
	if (locale === "it") return it_booking_waitlist_error(inputs)
	if (locale === "ru") return ru_booking_waitlist_error(inputs)
	if (locale === "pt") return pt_booking_waitlist_error(inputs)
	return ko_booking_waitlist_error(inputs)
});